import { z } from 'zod';

import { calculateVenueCo2DtoSchema } from '../co2/dto.type';
import { calculateVenueEnvDtoSchema } from '../env/dto.type';
import { calculateVenueEssDtoSchema } from '../ess/dto.type';

const projectVenueDtoSchema = z.object({
  id: z.number(),
  results: z.object({
    co2: calculateVenueCo2DtoSchema.optional(),
    ess: calculateVenueEssDtoSchema.optional(),
    env: calculateVenueEnvDtoSchema.optional(),
  }),
});

export const getSummaryImpactCalculateVenueForAllProjectsDtoSchema = z.object({
  data: z.array(projectVenueDtoSchema),
  limit: z.number(),
  skip: z.number(),
  total: z.number(),
});

export type SummaryImpactForAllProjectsDto = z.infer<
  typeof getSummaryImpactCalculateVenueForAllProjectsDtoSchema
>;
